import React, {Component, PropTypes} from 'react';
import {TimePicker} from 'material-ui';
import moment from 'moment';

class FrequencyAt extends Component {

  static getLabel = (filter) => {
    return moment(filter.value, 'hh:mm:ss').format('hh:mm A').toString();
  }

  getTimeObject = (timeString) => {
    return timeString ? new Date(moment(timeString, "HH:mm")) : {};
  }

  openTimePicker = (timePicker) => {
    this.refs[timePicker].openDialog();
  }

  setAtTime = (e, date) => {

    this.props.action({
     value: moment(date, 'HH:mm:ss'),
     label: FrequencyAt.getLabel({value: date})
   });
  }

  render() {

    return (
      <section>
        <div className="form-row">
          <TimePicker
            className="time-picker"
            ref="atTime"
            format="ampm"
            hintText="Select time"
            value={this.getTimeObject(this.props.filter.value)}
            onChange={this.setAtTime}
            fullWidth
          />
          <i className="icon icon-time icon-size-20 icon-secondary" onClick={() => this.openTimePicker('atTime')}/>
        </div>
      </section>
    );
  }
}

FrequencyAt.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired,
  countries: PropTypes.array
};

export default  FrequencyAt;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/components/frequency/FrequencyAt.js